<template>
  <v-container>
    <v-layout align-center class="LKPassportForm__title">
      <h3
        v-text="passportTitle"
      />
      <v-spacer />
      <v-btn v-if="closeable" icon @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-layout>

    <hr class="LKPassportForm__line">
    <v-row>
      <template v-for="(item, index) in passportRequisites">
        <v-col :key="index" :cols="item.cols || 4">
          <BTextarea
            :value="item.value"
            :label="item.label"
            :rows="1"
            rounded
            disabled
          />
        </v-col>
      </template>
    </v-row>

    <hr class="LKPassportForm__line">

    <LKPassportContextualData
      v-if="hasContexts"
      :data="data"
      :readonly="readonly"
      :on-contexts-updated="onContextsUpdated"
      :on-contexts-submit="onContextsSubmit"
    />

    <h4 style="margin-top: 1rem;">
      История изменений
    </h4>
    <ChangesView
      :passport-id="data.id"
      :action-types="['status_updated', 'activate']"
    />
    <v-divider />

    <h4 style="margin-top: 1rem;">
      История изменений объекта АТЕ
    </h4>
    <ChangesView :passport-id="data.id" :action-types="['ate_api_updated']" />
    <v-divider />
  </v-container>
</template>

<script>
import BTextarea from '@/components/forms/BTextarea.vue'
import { isEmpty } from 'lodash'
import LKPassportContextualData from '@/views/LKPassport/components/ContextualData/LKPassportContextualData.vue'
import { LkPassportApi } from '@/api/resources'
import ChangesView from './ChangesView/index.vue'

export default {
  name: 'LKPassportForm',
  components: {
    BTextarea, LKPassportContextualData, ChangesView,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    readonly: Boolean,
    closeable: Boolean,
    contextAlwaysVisible: Boolean,
  },
  computed: {
    passportRequisites() {
      const { data } = this
      const requisites = [
        {
          label: 'Регион',
          value: data.region_name,
        },
      ]

      if (data.municipality_code) {
        requisites.push({
          label: 'Муниципальное образование',
          value: data.municipality_name,
          cols: 8,
        })
      }
      if (data.school_code) {
        requisites.push(
          {
            label: 'Логин в ГИС ФИС ОКО',
            value: data.school_code,
          },
          {
            label: 'Краткое наименование ОО',
            value: data.school_name,
            cols: 8,
          },
          {
            label: 'Полное наименование ОО',
            value: data.long_name,
            cols: 12,
          },
        )
      }

      return requisites
    },
    hasContexts() {
      return this.contextAlwaysVisible || (!!this.data?.template
          && !isEmpty(this.data.template)
          && !!this.data?.contexts)
    },
    passportTitle() {
      const { data } = this
      if (data.school_code) {
        return 'Паспорт ОО'
      }
      if (data.municipality_code) {
        return 'Паспорт муниципалитета'
      }
      if (data.region_code) {
        return 'Паспорт региона'
      }
      return 'Паспорт'
    },
  },
  methods: {
    async onContextsUpdated(id, data) {
      try {
        const api = new LkPassportApi()
        await api.updateContexts(id, data)
        this.$emit('update:passport')
      } catch (e) {
        this.$notice.errors(e)
      }
    },
    async onContextsSubmit(id, data) {
      try {
        const api = new LkPassportApi()
        await api.updateContexts(id, data)
        await api.submitContexts(id)
        this.$emit('update:passport')
      } catch (e) {
        this.$notice.errors(e)
      }
    },
  },
}
</script>


<style lang="scss">
.LKPassportForm {
  overflow: auto;

  & &__title {
    margin-top: 12px;
    font-size: 22px;
  }

  &__line {
    height: 1px;
    margin: 22px 0 30px 0;
    color: $webflow-color-alert-line;
    background-color: $webflow-color-alert-line;
    border: 0;
  }
}
</style>
